import React, { useState } from 'react';
import './../css/auth.scss';
import Logo from './../assets/images/logo_auth.png';
import { ClipLoader } from 'react-spinners';
import LogoForgetPassword from './../assets/images/informasi-harga.png';
import FormForgotPassword from '../components/FormForgotPassword';
import MainBox from '../components/MainBox';
import Grid from '@mui/material/Grid2';

const ForgetPassword = () => {
  const [isReset, setIsReset] = useState(false);

  return (
    <>
      <div className="page">
        <MainBox>
          <Grid container>
            <Grid size={{
              lg: 8,
              md: 12,
            }}>
              <div className="px-5 pt-5 mt-5">
                <img width="80" src={Logo} alt='Market Auction Price' />
                <h3 className="mt-3 text-light">Market Auction Price</h3>
                <p className="mt-3 pr-5 text-light">
                  Market Auction Price (MAP) adalah aplikasi yang <br></br> menyediakan informasi harga pasaran mobil
                  lelang <br></br> terlengkap di Indonesia. Buatlah keputusan yang tepat <br></br> dan menguntungkan,
                  karena semua informasi harga <br></br> pasaran mobil yang mau Anda beli atau jual ada disini.
                </p>
              </div>
            </Grid>
            <Grid size={{
              lg: 4,
              md: 12
            }} sx={{
              padding: '1.5rem 2rem'
            }}>
              {!isReset ? (
                <div className="form-group form-forget bg-white rounded py-3 px-4">
                  <FormForgotPassword setIsReset={setIsReset} />
                </div>
              ) : (
                <div className="form-group form-login bg-white rounded d-flex justify-content-center align-items-center  py-5 h-100">
                  <ClipLoader loading size={100} />
                </div>
              )}
            </Grid>
          </Grid>
        </MainBox>
      </div>
      <div className="page-mobile">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center pt-5" style={{ backgroundColor: '#f0f0f0' }}>
            <img style={{ width: '80%', height: '60%' }} src={LogoForgetPassword} alt='Forgot Password' />
          </div>
          <div className="row pt-3">
            <div className="col-12 mt-2">
              <FormForgotPassword setIsReset={setIsReset} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
